<div class="_outer">
    <div class="_inner"
         [dfs]="'br:2px'"
         [ngSwitch]="isBusy">
        <icms-loader *ngSwitchCase="true"></icms-loader>
        <icms-icon class="_icon"
                   *ngSwitchDefault
                   [icon]="icon"></icms-icon>

    </div>
</div>
<ng-content></ng-content>